var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadImg03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -36.4,
    y: -36.4,
    width: 163.8,
    height: 163.8
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(18.2px)",
      clipPath: "url(#bgblur_0_5137_23511_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 36.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 13.7358,
    fill: "#0DA06A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5137_23511)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8074 29.3107C57.4871 29.063 58.2233 29.0145 58.9297 29.1709C59.636 29.3272 60.283 29.682 60.7946 30.1934C61.3063 30.7048 61.6613 31.3516 61.818 32.0578C61.9747 32.764 61.9265 33.5003 61.6792 34.1801L53.2961 59.3061C53.0921 59.9235 52.7331 60.4783 52.2534 60.9173C51.7738 61.3563 51.1894 61.6649 50.5564 61.8135C49.9249 61.9671 49.2642 61.954 48.6393 61.7756C48.0143 61.5971 47.4464 61.2594 46.9911 60.7955L42.4923 56.3178L37.7683 58.7619C37.5872 58.8558 37.3847 58.9009 37.1809 58.8926C36.9771 58.8843 36.779 58.8231 36.6061 58.7148C36.4332 58.6066 36.2915 58.4551 36.195 58.2754C36.0985 58.0957 36.0506 57.8939 36.056 57.69L36.2507 50.2216L52.7753 38.2192C52.9312 38.106 53.0632 37.9632 53.1639 37.799C53.2646 37.6348 53.3319 37.4523 53.3621 37.2621C53.3923 37.0718 53.3847 36.8775 53.3397 36.6902C53.2948 36.5029 53.2134 36.3262 53.1002 36.1704C52.987 36.0145 52.8442 35.8825 52.68 35.7818C52.5157 35.6811 52.3333 35.6138 52.143 35.5836C51.9528 35.5534 51.7585 35.561 51.5711 35.606C51.3838 35.6509 51.2072 35.7323 51.0513 35.8455L34.2475 48.0519L30.1897 43.9941C29.7523 43.5566 29.4299 43.0179 29.2511 42.4257C29.0723 41.8336 29.0426 41.2064 29.1646 40.6C29.2872 39.9373 29.5838 39.3192 30.024 38.8089C30.4642 38.2986 31.0322 37.9146 31.6697 37.6962H31.6791L56.8074 29.3107Z",
    fill: "#0DA06A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5137_23511_clip_path",
    transform: "translate(36.4 36.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    rx: 13.7358
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5137_23511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8382,
    height: 32.8382,
    fill: "white",
    transform: "translate(29.0811 29.0808)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadImg03);
export default __webpack_public_path__ + "static/media/lead-img03.ba31f3c45387d2eba449d367fa0f644d.svg";
export { ForwardRef as ReactComponent };